module.exports = __webpack_public_path__ + "static/img/6729_phase_function_Paper_Points.cce0ffd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6729_phase_function_Paper_Points.png
// module id = Uuj+
// module chunks = 0